
class QrCodeSystem {
  framework;
  successCallback;
  errorCallback;
  qrCode;

  constructor(_framework) {
    this.framework = _framework;
  }

  setSuccessCallback(successCallback) {
    this.successCallback = successCallback;
  }

  setErrorCallback(errorCallback) {
    this.errorCallback = errorCallback;
  }
  
  showScanQrCodeDialog() {
    try {
      window.JSInterface.doShowScanQrCodeDialog()
    }
    catch(error) {
      console.log(error);
    }     
  }  

  processQrCodeReading(qrCodeReading) {
    try {
      window.JSInterface.doConsoleLog("Incoming qrCode:" + qrCodeReading);
      if(this.successCallback !== null && this.successCallback !== undefined) {
        window.JSInterface.doConsoleLog("just before the call");
        if (typeof this.successCallback === 'function') {
          this.successCallback(qrCodeReading);
        }        
        window.JSInterface.doConsoleLog("after the call");
      }
    }
    catch(error) {
      console.log(error);
    }
  }

  notifyError(qrCodeError) {
    try {
      if(this.errorCallback !== null && this.errorCallback !== undefined) {
        this.errorCallback(qrCodeError);
      }
    }
    catch(error) {
      console.log(error);
    }    

  }  
}


export default QrCodeSystem;